import React, { ReactElement } from 'react';
import { Button, Col, Modal, Row } from 'antd';
import { RECONDIDERATION_DEFAULT_CONFIRM } from '../../constants/commonConstants';
import { RootState } from '../../../store';
import { useSelector } from 'react-redux';

const ReconsiderModal = ({ reconsiderModal, handleReConsiderModal }: any): ReactElement => {
    const { payerList: { payer } } = useSelector((state: RootState): RootState => state || {});
    return (
        <Modal
            visible={reconsiderModal}
            title={payer?.reconsiderAlertMessage !== null ? payer?.reconsiderAlertMessage : RECONDIDERATION_DEFAULT_CONFIRM}
            onCancel={handleReConsiderModal}
            footer={
                <Row className="justify-flex-end">
                    <Col>
                        <Button key="confirm" value="Proceed" onClick={handleReConsiderModal} type="primary" className="m-10">
                            Proceed
                        </Button>
                    </Col>
                    <Col>
                        <Button key="doLater" value="I'll do later" onClick={handleReConsiderModal} className="m-10">I'll do later</Button>
                    </Col>
                </Row>
            }
        />
    );
};
export default ReconsiderModal;
